<template>
  <div
    :class="[
      setClassSummary(data.type),
      extendClass,
      { 'mobile': isMobile }
    ]"
    :style="setStyleSummary(masterData, data.color)"
    class="container-summary-block"
  >
    <div class="item-name">{{ data.name }}</div>
    <div
      v-if="!isMobile"
      class="item-count"
    >
      0
    </div>

    <!-- Edit or Delete -->
    <div class="edit-or-delete">
      <div class="button">
        <!-- Edit -->
        <div
          class="edit"
          @click="openModal(data, index)"
        >
          <i class="fa fa-pencil-square-o" />
        </div>
        <!-- Delete -->
        <div
          v-if="!isDefault(data.key)"
          class="delete"
          @click="confirmDeleteSummaryBlock(index)"
        >
          <i class="fa fa-trash" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jMixSummaryWorkflow from '@/mixins/summary/jMixSummaryWorkflow';

export default {
  name: 'JSummaryWorkflow',
  mixins: [jMixSummaryWorkflow],

  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    openModal(data, index) {
      this.$emit('open-modal', data, index);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/summary/jSummaryWorkflow.vue